import { Component, ViewEncapsulation, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { WindowService } from 'src/shared/providers/window.service';
import { Util } from 'src/shared/util/util';

import { scrollContentWidth } from 'src/shared/components/scroll-wrapper/scroll-wrapper.component';

@Component({
    templateUrl: './upsell.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./upsell.scss'],
    standalone: false
})

export class UpsellPage implements OnInit {

  readonly desktopWidthContent: string = scrollContentWidth.LARGE;
  hasProperties = false;

  constructor(
    public windowService: WindowService,
    private util: Util,
  ) {}

  async ngOnInit() {
    try {
      this.getPageData();
    } catch (err) {
      this.util.showError((err.error && err.error.message) ? err.error.message : err.message, 10000);
    }
  }

  getPageData() {
    //TODO
  }

}
